import _defineProperty from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { TinyColor } from '@ctrl/tinycolor';
import { resetComponent } from '../../style';
import getArrowStyle, { MAX_VERTICAL_CONTENT_RADIUS } from '../../style/placementArrow';
import { genComponentStyleHook, mergeToken } from '../../theme/internal'; // =============================== Base ===============================

var genBaseStyle = function genBaseStyle(token) {
  var _$concat4, _$concat5, _$concat7, _Object$assign, _ref;

  var componentCls = token.componentCls,
      lineHeight = token.lineHeight,
      padding = token.padding,
      paddingXS = token.paddingXS,
      borderRadius = token.borderRadius,
      borderRadiusXS = token.borderRadiusXS,
      colorPrimary = token.colorPrimary,
      colorText = token.colorText,
      colorFill = token.colorFill,
      indicatorHeight = token.indicatorHeight,
      indicatorWidth = token.indicatorWidth,
      boxShadowTertiary = token.boxShadowTertiary,
      tourZIndexPopup = token.tourZIndexPopup,
      fontSize = token.fontSize,
      colorBgContainer = token.colorBgContainer,
      fontWeightStrong = token.fontWeightStrong,
      marginXS = token.marginXS,
      colorTextLightSolid = token.colorTextLightSolid,
      tourBorderRadius = token.tourBorderRadius,
      colorWhite = token.colorWhite,
      colorBgTextHover = token.colorBgTextHover,
      tourCloseSize = token.tourCloseSize,
      motionDurationSlow = token.motionDurationSlow,
      antCls = token.antCls;
  return [(_ref = {}, _defineProperty(_ref, componentCls, Object.assign(Object.assign({}, resetComponent(token)), (_Object$assign = {
    color: colorText,
    position: 'absolute',
    zIndex: tourZIndexPopup,
    display: 'block',
    visibility: 'visible',
    fontSize: fontSize,
    lineHeight: lineHeight,
    width: 520,
    '--antd-arrow-background-color': colorBgContainer,
    '&-pure': {
      maxWidth: '100%',
      position: 'relative'
    }
  }, _defineProperty(_Object$assign, "&".concat(componentCls, "-hidden"), {
    display: 'none'
  }), _defineProperty(_Object$assign, "".concat(componentCls, "-content"), {
    position: 'relative'
  }), _defineProperty(_Object$assign, "".concat(componentCls, "-inner"), (_$concat5 = {
    textAlign: 'start',
    textDecoration: 'none',
    borderRadius: tourBorderRadius,
    boxShadow: boxShadowTertiary,
    position: 'relative',
    backgroundColor: colorBgContainer,
    border: 'none',
    backgroundClip: 'padding-box'
  }, _defineProperty(_$concat5, "".concat(componentCls, "-close"), {
    position: 'absolute',
    top: padding,
    insetInlineEnd: padding,
    color: token.colorIcon,
    outline: 'none',
    width: tourCloseSize,
    height: tourCloseSize,
    borderRadius: token.borderRadiusSM,
    transition: "background-color ".concat(token.motionDurationMid, ", color ").concat(token.motionDurationMid),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      color: token.colorIconHover,
      backgroundColor: token.wireframe ? 'transparent' : token.colorFillContent
    }
  }), _defineProperty(_$concat5, "".concat(componentCls, "-cover"), {
    textAlign: 'center',
    padding: "".concat(padding + tourCloseSize + paddingXS, "px ").concat(padding, "px 0"),
    img: {
      width: '100%'
    }
  }), _defineProperty(_$concat5, "".concat(componentCls, "-header"), _defineProperty({
    padding: "".concat(padding, "px ").concat(padding, "px ").concat(paddingXS, "px")
  }, "".concat(componentCls, "-title"), {
    lineHeight: lineHeight,
    fontSize: fontSize,
    fontWeight: fontWeightStrong
  })), _defineProperty(_$concat5, "".concat(componentCls, "-description"), {
    padding: "0 ".concat(padding, "px"),
    lineHeight: lineHeight,
    wordWrap: 'break-word'
  }), _defineProperty(_$concat5, "".concat(componentCls, "-footer"), (_$concat4 = {
    padding: "".concat(paddingXS, "px ").concat(padding, "px ").concat(padding, "px"),
    textAlign: 'end',
    borderRadius: "0 0 ".concat(borderRadiusXS, "px ").concat(borderRadiusXS, "px"),
    display: 'flex'
  }, _defineProperty(_$concat4, "".concat(componentCls, "-indicators"), _defineProperty({
    display: 'inline-block'
  }, "".concat(componentCls, "-indicator"), {
    width: indicatorWidth,
    height: indicatorHeight,
    display: 'inline-block',
    borderRadius: '50%',
    background: colorFill,
    '&:not(:last-child)': {
      marginInlineEnd: indicatorHeight
    },
    '&-active': {
      background: colorPrimary
    }
  })), _defineProperty(_$concat4, "".concat(componentCls, "-buttons"), _defineProperty({
    marginInlineStart: 'auto'
  }, "".concat(antCls, "-btn"), {
    marginInlineStart: marginXS
  })), _$concat4)), _$concat5)), _defineProperty(_Object$assign, "".concat(componentCls, "-primary, &").concat(componentCls, "-primary"), _defineProperty({
    '--antd-arrow-background-color': colorPrimary
  }, "".concat(componentCls, "-inner"), (_$concat7 = {
    color: colorTextLightSolid,
    textAlign: 'start',
    textDecoration: 'none',
    backgroundColor: colorPrimary,
    borderRadius: borderRadius,
    boxShadow: boxShadowTertiary
  }, _defineProperty(_$concat7, "".concat(componentCls, "-close"), {
    color: colorTextLightSolid
  }), _defineProperty(_$concat7, "".concat(componentCls, "-indicators"), _defineProperty({}, "".concat(componentCls, "-indicator"), {
    background: new TinyColor(colorTextLightSolid).setAlpha(0.15).toRgbString(),
    '&-active': {
      background: colorTextLightSolid
    }
  })), _defineProperty(_$concat7, "".concat(componentCls, "-prev-btn"), {
    color: colorTextLightSolid,
    borderColor: new TinyColor(colorTextLightSolid).setAlpha(0.15).toRgbString(),
    backgroundColor: colorPrimary,
    '&:hover': {
      backgroundColor: new TinyColor(colorTextLightSolid).setAlpha(0.15).toRgbString(),
      borderColor: 'transparent'
    }
  }), _defineProperty(_$concat7, "".concat(componentCls, "-next-btn"), {
    color: colorPrimary,
    borderColor: 'transparent',
    background: colorWhite,
    '&:hover': {
      background: new TinyColor(colorBgTextHover).onBackground(colorWhite).toRgbString()
    }
  }), _$concat7))), _Object$assign))), _defineProperty(_ref, "".concat(componentCls, "-mask"), _defineProperty({}, "".concat(componentCls, "-placeholder-animated"), {
    transition: "all ".concat(motionDurationSlow)
  })), _defineProperty(_ref, ['&-placement-left', '&-placement-leftTop', '&-placement-leftBottom', '&-placement-right', '&-placement-rightTop', '&-placement-rightBottom'].join(','), _defineProperty({}, "".concat(componentCls, "-inner"), {
    borderRadius: Math.min(tourBorderRadius, MAX_VERTICAL_CONTENT_RADIUS)
  })), _ref), // ============================= Arrow ===========================
  getArrowStyle(token, {
    colorBg: 'var(--antd-arrow-background-color)',
    contentRadius: tourBorderRadius,
    limitVerticalRadius: true
  })];
}; // ============================== Export ==============================


export default genComponentStyleHook('Tour', function (token) {
  var borderRadiusLG = token.borderRadiusLG,
      fontSize = token.fontSize,
      lineHeight = token.lineHeight;
  var TourToken = mergeToken(token, {
    tourZIndexPopup: token.zIndexPopupBase + 70,
    indicatorWidth: 6,
    indicatorHeight: 6,
    tourBorderRadius: borderRadiusLG,
    tourCloseSize: fontSize * lineHeight
  });
  return [genBaseStyle(TourToken)];
});